import { render, staticRenderFns } from "./OpenMenuManage.vue?vue&type=template&id=7aaa59d2&"
import script from "./OpenMenuManage.vue?vue&type=script&lang=js&"
export * from "./OpenMenuManage.vue?vue&type=script&lang=js&"
import style0 from "./OpenMenuManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports